import React, { useState } from 'react';
import Carousel from 'react-material-ui-carousel';
import { CarouselStyle } from './Component.style';
import { ReactComponent as Delete } from 'assert/images/More/delete.svg';
import BasicIconButton from './BasicIconButton';
import BasicPopover from './Popover';
import { JobAlertPopover } from 'pages/jobs/JobPosts.style';
import Button from './Button';
import { useTranslation } from 'react-i18next';

export default function CustomCarousel({ items, handleDelete, display, ...props }) {
  const [isAlertPopoverOpen, setIsAlertPopoverOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <CarouselStyle>
      <Carousel
        {...props}
        indicatorContainerProps={{
          style: {
            marginTop: '6px',
            display: display || 'inherit'
          },
        }}
        navButtonsWrapperProps={{
          style: {
            height: '69%',
            margin: '7% 0',
            display: display || 'inherit'
          },
        }}
      >
        {items?.map((item, i) => (
          <div key={i} className="cmy-carousel-list">
            {handleDelete && typeof item === 'string' && (
              <div className="carousel-action">
                <BasicPopover
                  handlePopoverClick={() => setIsAlertPopoverOpen(true)}
                  isOpen={isAlertPopoverOpen}
                  action={
                    <div className="remove-icon">
                      <BasicIconButton
                        icon={<Delete />}
                        ariaLabel={'remove-icon'}
                        size="small"
                      />
                    </div>
                  }
                  content={
                    <JobAlertPopover className="job-alert-popover">
                     {t('BusinessPlace.DelImage')}
                      <div>
                        <Button
                          variant="text"
                          color="error"
                          label={t('BusinessPlace.Yes')}
                          onClick={() => {
                            handleDelete(i);
                            setIsAlertPopoverOpen(false);
                          }}
                        />
                        <Button
                          variant="text"
                          label={t('BusinessPlace.No')}
                          onClick={() => setIsAlertPopoverOpen(false)}
                        />
                      </div>
                    </JobAlertPopover>
                  }
                />
              </div>
            )}
            <img
              src={typeof item !== 'string' ? URL.createObjectURL(item) : item}
            />
          </div>
        ))}
      </Carousel>
    </CarouselStyle>
  );
}
